export const PACKAGE_NAME = 'experts_package';
export const METRICS_PREFIX = `services.${PACKAGE_NAME}`;

const BASE_ROUTE = '/freelancers/ajax';
export const Routes = {
    GetExpert: `${BASE_ROUTE}/freelancer`,
    NotableClients: `${BASE_ROUTE}/seller-notable-clients`,
    TranslatedSkills: `${BASE_ROUTE}/get-translated-skills`,
    SellerGigsCategories: `${BASE_ROUTE}/seller-gigs-categories`,
    MachineTranslate: `${BASE_ROUTE}/get-translated-about-expert`,
};
